<template>
  <div class="organization-list">
    <job-filters/>
    <data-table :service="OrganizationService"
                :entity="entity"
                :filters="filters"
                :columns="columns"
                :disablePermissionChecks="true"
                operations="add,edit,refresh"
                ref="table">
      <template v-slot:created_at="{row}">
        {{$formatDate(row.created_at, FRIENDLY_DATETIME_FORMAT)}}
      </template>
      <template v-slot:organisation_names="{row}">
        <template v-if="row.organisation_names && row.organisation_names.length">
          <badge v-for="orgName in row.organisation_names" :key="orgName.id" type="info">
            {{orgName.name}}
          </badge>
        </template>
        <template v-else>
          {{'- -'}}
        </template>
      </template>
      <template v-slot:active="{row}">
        <status-badge :status="row.active === false ? 'inactive': 'active'">
          {{row.active === false ? 'inactive': 'active'}}
        </status-badge>
      </template>
    </data-table>

  </div>
</template>
<script>
  import get from 'lodash/get'
  import JobFilters from '@/views/admin/jobs/JobFilters'
  import OrganizationService from 'src/services/OrganizationService'
  import entities from 'src/config/entities'
  import Badge from 'src/components/Badge'
  import { FRIENDLY_DATETIME_FORMAT } from 'src/config/dateUtils'

  export default {
    name: 'organization-list',
    components: {
      JobFilters,
      Badge,
    },
    data () {
      return {
        FRIENDLY_DATETIME_FORMAT,
        OrganizationService,
        entity: entities.ORGANIZATION
      }
    },
    computed: {
      filters () {
        return [
          {
            key: 'with',
            value: 'organisation_names,organisation_clients,organisation_info,organisation_segments'
          },
          {
            key: 'sort',
            value: '+created_at'
          }
        ]
      },
      columns () {
        return [
          {
            prop: 'name',
            label: this.$t('organization.list.labels.name'),
            minWidth: '150px',
            sortable: true
          },
          {
            prop: 'active',
            label: this.$t('organization.list.labels.active'),
            minWidth: '80px',
            sortable: true,
            align: 'center'
          },
          {
            prop: 'organisation_names',
            label: this.$t('organization.list.labels.organisation_names'),
            minWidth: '180px',
          },
          {
            prop: 'created_at',
            label: this.$t('generic.createdAt'),
            minWidth: '180px',
            sortable: true,
          }
        ]
      }
    },
    methods: {
      get
    }
  }
</script>
<style>
</style>
